<template>
<div>
  <div
    v-for="(step, index) in instructions.steps"
    :key="index"
    class="list-item"
  >
    <div>
      <div :class="['list-item__title-container', step.stepNumber && 'list-item__chip']">
        <p
          v-if="step.stepNumber"
          class="list-item__number"
          :name="`${instructions.currentStep}_step${step.stepNumber}_stepNum`"
          :id="`${instructions.currentStep}_step${step.stepNumber}_stepNum`"
        >{{ step.stepNumber }}</p>
        <BaseImage
          v-if="step.icon"
          :src="step.icon"
          :name="`${instructions.currentStep}_step${index + 1}_icon`"
          :id="`${instructions.currentStep}_step${index + 1}_icon`"
          class="list-item__icon"
        />
        <!-- Step Title Standard -->
        <p
          v-if="step.title || step.titleTx"
          :name="`${instructions.currentStep}_step${index + 1}_title`"
          :id="`${instructions.currentStep}_step${index + 1}_title`"
          class="list-item__title"
        >
          <strong>{{ step.titleTx ? $t(step.titleTx) : step.title }}</strong>
        </p>
        <!-- Step Title Weak (no strong tag) -->
        <p
          v-if="step.titleWeak || step.titleWeakTx"
          :name="`${instructions.currentStep}_step${index + 1}_title`"
          :id="`${instructions.currentStep}_step${index + 1}_title`"
          class="list-item__title"
        >{{ step.titleWeakTx ? $t(step.titleWeakTx) : step.titleWeak }}</p>
      </div>
      <div>
        <p
          v-if="step.description || step.descriptionTx"
          :name="`${instructions.currentStep}_step${index + 1}_description`"
          :id="`${instructions.currentStep}_step${index + 1}_description`"
          class="list-item__subtitle"
        >{{ step.descriptionTx ? $t(step.descriptionTx) : step.description }}</p>

        <p
          v-if="step.callout || step.calloutTx"
          class="list-item__callout"
          :name="`${instructions.currentStep}_step${index + 1}_callout`"
          :id="`${instructions.currentStep}_step${index + 1}_callout`"
        >{{ step.calloutTx ? $t(step.calloutTx) : step.callout }}</p>

        <!-- Start MORE INFO -->
        <div class="list-item__more-info-container">
          <router-link
            v-if="step.moreInfo"
            tag="div"
            class="list-item__more-info"
            :to="{
              name: step.moreInfo.nextStepName,
              params: {
                brand: $route.params.brand,
                device: $route.params.device,
                step: step.moreInfo.nextStep,
              },
              query: {
                mode: $route.query.mode || 'light'
              },
            }"
          >
            <img
                v-if="step.moreInfo.includeIcon && step.moreInfo.src"
                class="icon-big-img"
                :src="step.moreInfo.src"
                :style="{
                background: brandTheme && brandTheme.primaryColor
                    ? brandTheme.primaryColor
                    : '#000000'
                }"
                :name="`${instructions.currentStep}_moreInfo_icon`"
                :id="`${instructions.currentStep}_moreInfo_icon`"
            />
            <img
                v-else-if="step.moreInfo.includeIcon"
                class="icon-img"
                src= "@/assets/images/info-circle.svg"
                :style="{
                background: brandTheme && brandTheme.primaryColor
                    ? brandTheme.primaryColor
                    : '#000000'
                }"
                :name="`${instructions.currentStep}_moreInfo_icon`"
                :id="`${instructions.currentStep}_moreInfo_icon`"
            />
            <p
              v-if="step.moreInfo.primaryText || step.moreInfo.primaryTx"
              :name="`${instructions.currentStep}_moreInfo_primaryText`"
              :id="`${instructions.currentStep}_moreInfo_primaryText`"
            >{{ step.moreInfo.primaryTx ? $t(step.moreInfo.primaryTx) : step.moreInfo.primaryText }}</p>
          </router-link>
        </div>
        <!-- End MORE INFO -->

        <BaseImage
          v-if="step.image"
          :src="step.image"
          :name="`${instructions.currentStep}_step${index + 1}_image`"
          :id="`${instructions.currentStep}_step${index + 1}_image`"
          class="list-item__image"
        />

      </div>
    </div>
  </div>
</div>
</template>

<script>
import BaseImage from './BaseImage.vue';

export default {
  name: 'BaseSteps',
  components: {
    BaseImage,
  },
  props: {
    instructions: {
      type: Object,
      required: true,
    },
    brandTheme: {
      type: Object,
    }
  },
}
</script>